import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { get } from '@wp-g2/create-styles';
import { colorize, getComputedColor, is } from '@wp-g2/utils';
import { space } from '../mixins/space';
import { config } from './config';
import { generateColorAdminColors } from './utils';
var baseTheme = Object.freeze(Object.assign({}, config));
/**
 * @param {(props: { get: typeof get, theme: typeof baseTheme, color: typeof colorize, space: typeof space }) => Record<string, string>} callback
 * @return {Record<string, string>}
 */

export function createTheme(callback) {
  if (typeof callback !== 'function') return {};
  var customConfig = callback({
    get: get,
    theme: baseTheme,
    color: colorize,
    space: space
  });
  if (!is.plainObject(customConfig)) return {};
  var colorAdminColors = {};

  if (customConfig.colorAdmin) {
    var colorAdminValue = getComputedColor(customConfig.colorAdmin);
    colorAdminColors = generateColorAdminColors(colorAdminValue);
  }

  return _objectSpread(_objectSpread({}, customConfig), colorAdminColors);
}